<template>

  <div>

    <loading v-show="showLoading"></loading>

    <div class="order-list-back"  v-show="!showLoading" >

      <div class="order-list-bar">
        <div :class="[isAll==true?'order-list-bar-choice':'order-list-bar-noChoice']" @click="all()">
          全部
          <span v-show="isAll == true"></span>
        </div>
        <div :class="[isPay==true?'order-list-bar-choice':'order-list-bar-noChoice']" @click="pay()">
          待付款
          <span v-show="isPay == true"></span>
        </div>
        <div :class="[isShip==true?'order-list-bar-choice':'order-list-bar-noChoice']" @click="ship()">
          待发货
          <span v-show="isShip == true"></span>
        </div>
        <div :class="[isReward==true?'order-list-bar-choice':'order-list-bar-noChoice']" @click="reward()">
          待收货
          <span v-show="isReward == true"></span>
        </div>
        <div :class="[isEvaluation==true?'order-list-bar-choice':'order-list-bar-noChoice']" @click="evaluation()">
          待评价
          <span v-show="isEvaluation == true"></span>
        </div>
      </div>

      <div class="order-list-content" v-if="orderList">

        <div class="order-list-noData" v-if="orderList.length==0">
          没有更多数据了
        </div>

        <div>
          <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
            <div>
              <div class="order-list-each" v-for="(order,index) in orderList" :key="index" @click.stop="goDetail(order.orderId,order.statusName,order.productStoreId,order.cardType)">
                <div class="order-list-head">
                  <div class="order-list-head-time"  v-if="status != 3">
                    {{order.orderDate|formatDate}}
                  </div>
                  <div class="order-list-head-time" v-if="status == 3">
                    包裹号:{{order.shipmentId}}
                  </div>
                  <div class="order-list-head-status">
                    {{order.statusName}}
                  </div>
                </div>
                <div class="order-list-goods">
                  <div class="order-list-goods-each" v-for="(goods,index) in order.productList"
                       v-if="status == 0 ||status==1||status == 2">
                    <div class="order-list-goods-left">
                      <van-image :src="goods.imgUrl" fit="cover">
                        <template v-slot:error></template>
                      </van-image>
                    </div>
                    <div class="order-list-goods-right">
                      <div class="order-list-goods-name">
                        {{goods.productName}}
                      </div>
                      <div class="order-list-goods-div">
                        <div class="order-list-goods-spec" v-show='goods.productFeatureList.length>0'>
                          <!--尺寸:-->
                          {{goods.productFeat}}
                        </div>
                        <div class="order-list-goods-num">
                          x{{goods.quantity}}
                        </div>
                      </div>
                      <div class="order-list-goods-div-bottom">
                        <div class="order-list-goods-price">
                          ¥{{goods.price}}
                        </div>
                        <div class="order-list-total-button margin-top" v-show="goods.isReview==0" v-if="order.statusName=='已完成'||order.statusName=='待评价'" @click.stop="goEval(order.orderId,goods.productId,goods,goods.orderItemSeqId)">
                          <button class="order-list-button-choice">去评价</button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="order-list-goods-each" v-for="(goods,index) in order.shipmentList"
                       v-if="status == 3||status == 4">
                    <div class="order-list-goods-left">
                      <van-image :src="goods.imgUrl" fit="cover">
                        <template v-slot:error></template>
                      </van-image>
                    </div>
                    <div class="order-list-goods-right">
                      <div class="order-list-goods-name">
                        {{goods.productName}}
                      </div>
                      <div class="order-list-goods-div">
                        <div class="order-list-goods-spec" v-show="goods.productFeatureList.length>0">
                          <!--尺寸:-->
                          {{goods.productFeat}}
                        </div>
                        <div class="order-list-goods-num">
                          x{{goods.quantity}}
                        </div>
                      </div>
                      <div class="order-list-goods-div-bottom">
                        <div class="order-list-goods-price">
                          ¥{{goods.price}}
                        </div>
                        <div class="order-list-total-button margin-top" v-if="order.statusName=='已完成'||order.statusName=='待评价'" @click.stop="goEval(order.orderId,goods.productId,goods,order.orderItemSeqId)">
                          <button class="order-list-button-choice">去评价</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="order-list-total">
                  <div class="order-list-total-price" v-if="status==0||status==1||status==2">
                    共{{order.productList.length}}件商品 合计:<span>¥{{order.price.totalPrice}}</span>
                  </div>
                  <div class="order-list-total-price" v-if="status==3||status==4">
                    共{{order.shipmentList.length}}件商品
                  </div>
                  <div class="order-list-total-button">
                    <button class="order-list-button-choice" v-if="order.statusName=='待付款'" @click.stop="goPay(order.orderId,order.price.totalPrice)">立即付款</button>
                    <button class="order-list-button-noChoice" v-if="order.statusName=='待付款'" @click.stop="goCanel(order.orderId)">取消订单</button>
                    <button class="order-list-button-choice" v-if="order.statusName=='已发货'||order.statusName=='部分发货'||order.statusName=='全部发货'||order.statusName=='部分收货'||order.statusName=='待收货'" v-show="order.productStoreId=='OnlineStore'||order.productStoreId=='KCoinStore'||order.productStoreId=='GiftCardStore'" @click.stop="goSure(order.orderId,order.shipmentId)">确认收货</button>
                    <button class="order-list-button-noChoice" v-if="order.statusName=='已发货'||order.statusName=='部分发货'||order.statusName=='全部发货'||order.statusName=='部分收货'||order.statusName=='待收货'" v-show="order.productStoreId=='OnlineStore'||order.productStoreId=='KCoinStore'||order.productStoreId=='GiftCardStore'" @click.stop="goLog(order.orderId,order.shipmentId)">查看物流</button>
                  </div>
                </div>
              </div>
              <refresh @zj-load="loadMore" :lastPage='{total: !allLoaded, empty: orderList.length,show:show}'></refresh>
            </div>
          </van-pull-refresh>

        </div>

      </div>

      <!--footer-->
      <footerView :cartInfo="{cartNum:catNum}"></footerView>

    </div>
  </div>

</template>

<script>
  import Vue from 'vue'
  import { storeName,prodCatalogId,loginInfo,shareOnlineUrl ,paymentUrl} from '@/router/Constant'
  import { getOrderList,orderCancel,getOrderLogistics,confirmOrderRecive,login,getShoppingCartNum,weixinPays,cloudPays} from '@/router/api'
  import { NavBar, Image, Grid, Tabbar, Toast,PullRefresh,Dialog} from 'vant'
  import loading from '@/components/page/common/loading.vue'
  import { setStore,getStore,getCookie,setCookie,GetQueryString,getQueryVariable } from '@/utils/mUtil';
  import refresh from '@/components/page/common/refresh.vue';
  import footerView from '../common/footer';

  export default {
    name: "orderList",
    data(){
          return{
            showLoading:true,
            isAll:true,
            isPay:false,
            isShip:false,
            isReward:false,
            isEvaluation:false,
            status:0,
            token:getStore('externalLoginKey'),
            viewIndex:0,
            viewSize:5,
            orderList:[],
            show: false,
            allLoaded: false,
            isLoading:false,
            productStoreId:storeName,
            catNum:0,
            payMap:{}
          }
        },

    mounted(){
      this.initData()
      this.orderStatus()
    },
    components:{
      [NavBar.name]: NavBar,
      [Image.name]: Image,
      [Grid.name]: Grid,
      [Tabbar.name]: Tabbar,
      [Toast.name]: Toast,
      [PullRefresh.name]: PullRefresh,
      loading,
      refresh,
      [Dialog.Component.name]: Dialog.Component,
      footerView
    },

    filters: {
      formatDate: function (value) {
        if(value!=null&&value!=''&&value!=undefined ){
          let date = new Date(value)
          let y = date.getFullYear()
          let MM = date.getMonth() + 1
          MM = MM < 10 ? ('0' + MM) : MM
          let d = date.getDate()
          d = d < 10 ? ('0' + d) : d
          // let h = date.getHours();
          // h = h < 10 ? ('0' + h) : h;
          // let m = date.getMinutes();
          // m = m < 10 ? ('0' + m) : m;
          // let s = date.getSeconds();
          // s = s < 10 ? ('0' + s) : s;
          return y + '-' + MM + '-' + d
        }else{
          return ''
        }

      }
    },

    methods:{

      async initData() {
        if(getStore('status')){
          this.status = getStore('status')
        }
        if (getStore('islogIn') != 'true') {
          this.dialogAction('查看订单需要登录，是否现在登录？');
        } else{
          if(window.location.href.indexOf("?")!=-1){
            //链接带单数
            console.log(window.location.href)
            // this.status = window.location.href.substring(window.location.href.indexOf('=')+1,window.location.href.length)
            this.status = getQueryVariable('status')
            console.log("status:"+this.status)
            if (this.status == '') {
              this.status = 0
            }
          }
          this.getOrderList()
          this.getShoppingCartNum();
        }
      },

      //用户点击确定登陆按钮
      dialogAction(msg){
        Dialog.confirm({
          message: msg
        }).then(() => {
          if (getStore('fromType')=='mini') {
            wx.miniProgram.switchTab({url:'../../pages/menu/menu'})
          } else {
            wx.miniProgram.switchTab({url:'../../pages/menu/menu'})
          }
        }).catch(() => {

        });
      },

      //查看购物车商品数量
      getShoppingCartNum(){
        getShoppingCartNum({externalLoginKey:getStore('externalLoginKey'),productStoreId:this.productStoreId})
          .then(res => {
            console.log(res.catNum)
            this.catNum = res.catNum;
          })
          .catch(err => {
            console.log(err);
          });
      },

      //判断当前订单状态
      orderStatus:function(){
        if(this.status==0){
          this.isAll = true
          this.isPay  = false
          this.isShip = false
          this.isReward = false
          this.isEvaluation = false
        }else if(this.status==1){
          this.isAll = false
          this.isPay  = true
          this.isShip = false
          this.isReward = false
          this.isEvaluation = false
        }else if(this.status == 2){
          this.isAll = false
          this.isPay  = false
          this.isShip = true
          this.isReward = false
          this.isEvaluation = false
        }else if(this.status == 3){
          this.isAll = false
          this.isPay  = false
          this.isShip = false
          this.isReward = true
          this.isEvaluation = false
        }else if(this.status == 4){
          this.isAll = false
          this.isPay  = false
          this.isShip = false
          this.isReward = false
          this.isEvaluation = true
        }
      },

      //点击全部按钮
      all:function () {
        this.showLoading = true
        this.isAll = true
        this.isPay  = false
        this.isShip = false
        this.isReward = false
        this.isEvaluation = false
        this.status = 0
        this.viewIndex = 0
        this.orderList = []
        this.getOrderList()
      },
      //点击待付款按钮
      pay:function () {
        this.showLoading = true
        this.isAll = false
        this.isPay  = true
        this.isShip = false
        this.isReward = false
        this.isEvaluation = false
        this.status = 1
        this.viewIndex = 0
        this.orderList = []
        this.getOrderList()
      },
      //点击待发货按钮
      ship:function () {
        this.showLoading = true
        this.isAll = false
        this.isPay  = false
        this.isShip = true
        this.isReward = false
        this.isEvaluation = false
        this.status = 2
        this.viewIndex = 0
        this.orderList = []
        this.getOrderList()
      },
      //点击待收获按钮
      reward:function () {
        this.showLoading = true
        this.isAll = false
        this.isPay  = false
        this.isShip = false
        this.isReward = true
        this.isEvaluation = false
        this.status = 3
        this.viewIndex = 0
        this.orderList = []
        this.getOrderList()
      },
      //点击待评价按钮
      evaluation:function () {
        this.showLoading = true
        this.isAll = false
        this.isPay  = false
        this.isShip = false
        this.isReward = false
        this.isEvaluation = true
        this.status = 4
        this.viewIndex = 0
        this.orderList = []
        this.getOrderList()
      },

      //获取订单列表
      getOrderList:function () {
        let params = {
          externalLoginKey:this.token,
          status:this.status,
          viewIndex:this.viewIndex,
          viewSize:this.viewSize
        }
        getOrderList(params)
          .then(res => {
            this.showLoading = false
            console.log(res);
            if(res._ERROR_MESSAGE_!=undefined){
              // Toast(res._ERROR_MESSAGE_)
              this.allLoaded = true
            }else{
              if (res.resultMap.orderList) {
                // if (res.resultMap.orderList.length == 0){
                //   Toast("未搜索到您想要的宝贝");
                // }

                if (res.resultMap.orderList.length < this.viewSize) {
                  this.allLoaded = true
                } else {
                  this.allLoaded = false
                }
                //
                if(this.viewIndex==0){
                  this.show = false
                }else{
                  this.show = true
                }
                var oldProductList = this.orderList
                var newProductList = oldProductList.concat(res.resultMap.orderList)
                this.orderList = newProductList
                this.viewIndex = res.resultMap.viewIndex;
                if(this.status == 0||this.status==1||this.status == 2){
                  for(var i = 0;i<this.orderList.length;i++){
                    for(var j = 0;j<this.orderList[i].productList.length;j++){
                      var feat = ''
                      for(var m =0;m<this.orderList[i].productList[j].productFeatureList.length;m++){
                        feat += this.orderList[i].productList[j].productFeatureList[m]+','
                      }
                      this.orderList[i].productList[j].productFeat = feat.substring(0,feat.length-1);
                    }
                  }
                }else{
                  for(var i = 0;i<this.orderList.length;i++){
                    var feat = ''
                    for(var j = 0;j<this.orderList[i].shipmentList.length;j++){
                      for(var m =0;m<this.orderList[i].shipmentList[j].productFeatureList.length;m++){
                        feat += this.orderList[i].shipmentList[j].productFeatureList[m]+','
                      }
                      this.orderList[i].shipmentList[j].productFeat = feat.substring(0,feat.length-1);
                    }
                  }
                }
              } else {
                this.allLoaded = true
                Toast("未搜索到您想要的宝贝");
              }
            }
          })
          .catch(err => {
            this.showLoading = false
            console.log(err);
          });
      },

      //上拉加载
      loadMore() {
        if (!this.allLoaded) {
          this.viewIndex ++;
          this.getOrderList()
        }
      },

      //下拉刷新
      onRefresh() {
        setTimeout(() => {
          this.orderList = []
          this.viewIndex = 0
          this.getOrderList()
          this.isLoading = false
        }, 1000);
      },

      //跳转至详情页面
      goDetail:function(orderId,statusName,productStoreId,cardType){
        setStore('status',this.status)
        if(productStoreId=='Tickets'){
          this.$router.push({name:'orderDetailTicket',query:{orderId:orderId,statusName:statusName,status:this.status,productStoreId:productStoreId}})
        } else if (productStoreId=='OnlineStore'){
          this.$router.push({name:'orderDetail',query:{orderId:orderId,statusName:statusName,status:this.status,productStoreId:productStoreId}})
        } else if (productStoreId.indexOf("Hotel") > 0) {
          this.$router.push({name:'orderDetailHotel',query:{orderId:orderId,statusName:statusName,status:this.status,productStoreId:productStoreId}})
        }else if (productStoreId=='GiftCardStore'){
          if(cardType=='entityCard'){
            this.$router.push({name:'orderDetailGift',query:{orderId:orderId,statusName:statusName,status:this.status,productStoreId:productStoreId,cardType:cardType}})
          }else{
            this.$router.push({name:'orderDetailGift',query:{orderId:orderId,statusName:statusName,status:this.status,productStoreId:productStoreId,cardType:cardType}})
          }
        }else if(productStoreId=='KCoinStore'){
          this.$router.push({name:'orderDetailExchange',query:{orderId:orderId,statusName:statusName,status:this.status,productStoreId:productStoreId}})
        }

      },

      //跳转至评价页面
      goEval:function (orderId,goodsId,goods,orderItemSeqId) {
        setStore('status',this.status)
        setStore("goods",goods)
        this.$router.push({name:'orderEvaluation',query:{orderId:orderId,productId:goodsId,orderItemSeqId:orderItemSeqId}})
      },

      // 用户支付
      goPay:function (orderId,totalPrice) {
        Dialog.confirm({
          title: '支付订单',
          message: '确认要支付该订单吗?'
        }).then(() => {

          console.log(paymentUrl+'?orderId='+orderId+'&totalPrice='+totalPrice+'&externalLoginKey='+getStore('externalLoginKey'))
          wx.miniProgram.navigateTo({url:paymentUrl+'?orderId='+orderId+'&totalPrice='+totalPrice+'&externalLoginKey='+getStore('externalLoginKey')})

        //   let params = {
        //     orderId:orderId,
        //     externalLoginKey:this.token
        //   }
        //   weixinPays(params)
        //     .then(res => {
        //       console.log(res);
        //       if(!res._EVENT_MESSAGE_){
        //         // this.scanCode = res.scanCode
        //         // console.log("scanCode========="+this.scanCode)
        //         // window.location.href = this.scanCode
        //
        //
        //         this.payMap = res.payMap
        //         if (typeof WeixinJSBridge == "undefined"){
        //           if( document.addEventListener ){
        //             document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady(), false);
        //           }else if (document.attachEvent){
        //             document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady());
        //             document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady());
        //           }
        //         }else{
        //           this.onBridgeReady();
        //         }
        //       }else{
        //         Toast({message:'获取参数失败'})
        //       }
        //
        //     })
        //     .catch(err => {
        //       this.showLoading = false
        //       console.log(err);
        //     });
        }).catch(() => {
          // on cancel
        });

      },

      //支付参数获取成功后掉取方法
      onBridgeReady:function(){
        WeixinJSBridge.invoke(
          'getBrandWCPayRequest', {
            "appId":this.payMap.appId,     //公众号名称，由商户传入
            "timeStamp":this.payMap.timeStamp,         //时间戳，自1970年以来的秒数
            "nonceStr":this.payMap.nonceStr, //随机串
            "package":this.payMap.package,
            "signType":this.payMap.signType,         //微信签名方式：
            "paySign":this.payMap.paySign //微信签名
          },
          function(res){
            if(res.err_msg == "get_brand_wcpay_request:ok" ){
              // 使用以上方式判断前端返回,微信团队郑重提示：
              //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
              Toast({message:'支付成功'})
              setTimeout(() => {
                window.location.href = shareOnlineUrl + "orderList?&externalLoginKey="+getStore('externalLoginKey')
              }, 3000);
            }else if(res.err_msg == "get_brand_wcpay_request:cancel"){
              Toast({message:'取消成功'})
              setTimeout(() => {
                window.location.href = shareOnlineUrl + "orderList?&externalLoginKey="+getStore('externalLoginKey')
              }, 3000);
            }else if(res.err_msg == "get_brand_wcpay_request:fail"){
              Toast({message:'支付失败'})
              setTimeout(() => {
                window.location.href = shareOnlineUrl + "orderList?&externalLoginKey="+getStore('externalLoginKey')
              }, 3000);
            }
          });
        },


      //用户取消订单
      goCanel:function (orderId) {
        Dialog.confirm({
          title: '取消订单',
          message: '确认要取消该订单吗?'
        }).then(() => {
          let params = {
            productStoreId:this.productStoreId,
            orderId:orderId,
            externalLoginKey:this.token
          }
          orderCancel(params)
            .then(res => {
              console.log(res);
              if(!res._EVENT_MESSAGE_){
                Toast({message:'取消订单成功'})
                this.orderList = []
                this.viewIndex = 0
                this.getOrderList()
                this.$forceUpdate();
              }else{
                Toast({message:res._EVENT_MESSAGE_})
              }
            })
            .catch(err => {
              console.log(err);
            });
        }).catch(() => {
          // on cancel
        });

      },

      //用户确认收货
      goSure:function (orderId,shipmentId) {
        if(this.status!=3){
          this.reward()
        } else {
          Dialog.confirm({
            title: '确认收货',
            message: '确认收到该宝贝了吗?'
          }).then(() => {
            let params = {
              productStoreId:this.productStoreId,
              orderId:orderId,
              externalLoginKey:this.token,
              shipmentId:shipmentId
            }
            confirmOrderRecive(params)
              .then(res => {
                console.log(res);
                if(!res._ERROR_MESSAGE_){
                  Toast({message:'确认收货成功'})
                  this.orderList = []
                  this.viewIndex = 0
                  this.getOrderList()
                  this.$forceUpdate();
                }else{
                  Toast({message:res._EVENT_MESSAGE_})
                }
              })
              .catch(err => {
                console.log(err);
              });
          }).catch(() => {
            // on cancel
          });
        }
      },

      //用户查看物流
      goLog:function (orderId,shipmentId) {
        setStore('status',this.status)
        if(this.status!=3){
          this.reward()
        }else{
          this.$router.push({name:'orderLogistics',query:{orderId:orderId,shipmentId:shipmentId}})
        }
      }
    }
  }
</script>

<style>
  .order-list-back{
    background-color: #f8f8f8;
  }

  .order-list-bar{
    background: white;
    width:100%;
    height: 2.5rem;
    line-height: 2.5rem;
    position: fixed;
    top: 0rem;
    z-index: 99;
  }
  .order-list-bar div{
    width:calc(100% / 5);
    float: left;
    text-align: center;
    font-size: 0.8125rem;
    height: 2.5rem;
    line-height: 2.5rem;
  }
  .order-list-bar div span{
    display: block;
    width: 1.625rem;
    border-bottom: 1px solid #EB84AB;
    margin-left: 1.5rem;
  }
  .order-list-bar-choice{
    color:#333333;
  }
  .order-list-bar-noChoice{
    color:#9E9E9E;
  }
  .order-list-content{
    width:100%;
    background-color: #F8F8F8;
    padding-top: 3.125rem;
    /*margin-bottom: 0.625rem;*/
  }
  .order-list-each{
    width:100%;
    background-color: white;
    margin-bottom: 0.625rem;
  }
  .order-list-head{
    width:21.4375rem;
    height: 2.28125rem;
    line-height: 2.28125rem;
    margin: 0 auto;
  }
  .order-list-head-time{
    display: inline-block;
    vertical-align: top;
    font-size: 0.875rem;
    color:#333333;
  }
  .order-list-head-status{
    float: right;
    font-size: 0.875rem;
    color:#EB84AB;
  }
  .order-list-goods{
    width:100%;
    border-top: 1px solid #e7e7e7;
  }
  .order-list-goods-each{
    width:100%;
    border-bottom: 1px solid #e7e7e7;
    padding-bottom: 0.9375rem;
    padding-top: 0.9375rem;
  }
  .order-list-goods-left{
    display: inline-block;
    vertical-align: top;
    height: 5rem;
    margin-left: 1rem;
    margin-right:0.6875rem;
  }
  .order-list-goods-left .van-image{
    width:5rem;
    height: 5rem;
  }
  .order-list-goods-right{
    width:calc(100% - 8rem);
    display: inline-block;
    vertical-align: top;
  }
  .order-list-goods-name{
    font-size: 0.875rem;
    color:#333;
    line-height: 1.25rem;
  }
  .order-list-goods-div{
    width:100%;
    min-height: 1.25rem;
    line-height: 1.25rem;
    margin-bottom: 0.25rem;
  }
  .order-list-goods-spec{
    display: inline-block;
    vertical-align: top;
    color:#9E9E9E;
    font-size: 0.75rem;
    width:12.5rem;
  }
  .order-list-goods-num{
    float: right;
    vertical-align: top;
    color:#33312E;
    font-size: 0.9375rem;
  }
  .order-list-goods-div-bottom{
    width:100%;
    height: 1.875rem;
    line-height: 1.875rem;
  }
  .order-list-goods-price{
    color:#EB84AB;
    font-size: 1rem;
    display: inline-block;
    vertical-align: top;
  }
  .order-list-goods-div-bottom button{
    float: right;
    width:3.75rem;
    height: 1.40625rem;
    line-height: 1.40625rem;
    border-radius: 0.703125rem;
    color:#EB84AB;
    font-size: 0.75rem;
    text-align: center;
    border: 1px solid #EB84AB;
    padding: 0;
  }
  .order-list-total{
    width:21.4375rem;
    height: 2.71875rem;
    line-height: 2.71875rem;
    margin: 0 auto;
    font-size: 0.9375rem;
  }
  .order-list-total span{
    color:#EB84AB
  }
  .order-list-total-price{
    font-size: 0.875rem;
    color:#333;
    display: inline-block;
    vertical-align: top;
  }
  .order-list-total-price span{
    color:#EB84AB
  }
  .order-list-total-button{
    float: right;
    margin-top: 0.5rem;
  }
  .margin-top{
    margin-top: 0.2rem;
  }
  .order-list-total-button button{
    width:3.75rem;
    height: 1.40625rem;
    border-radius: 0.703125rem;
    float: right;
    font-size: 0.71825rem;
    text-align: center;
    line-height: 1.40625rem;
    padding: 0;
    margin-left: 0.625rem;
  }
  .order-list-button-choice{
    border: 1px solid #EB84AB;
    color:#EB84AB;
  }
  .order-list-button-noChoice{
    border: 1px solid #9E9E9E;
    color:#9E9E9E;
  }
  .order-list-noData{
    font-size: 1rem;
    color:#333;
    width:100%;
    text-align: center;
    background-color: white;
    padding-top: 3.125rem;
  }




</style>



// WEBPACK FOOTER //
// src/components/page/mine/orderList.vue